export const achievementData = {
    bio : "We are trying to prove ourselves wrong as quickly as possible, because only in that way can we find progress. ― Richard P. Feynman",
    achievements : [
        {
            id : 1,
            title : 'Front-End Engineer Career Path',
            details : 'Codecademy Pro curriculum included 129 lessons and 77 projects to complete.',
            date : '7/1/2022',
            field : 'Programming',
            image : 'https://user-images.githubusercontent.com/91221861/176955602-6dbf71c8-f151-4aab-95c7-328b1d53f042.png'
        },
        {
            id : 2,
            title : 'Learn Git & GitHub',
            details : 'A CLI & version control course from Codecademy',
            date : '2/21/2022',
            field : 'version control',
            image : 'https://user-images.githubusercontent.com/91221861/166742005-1e5614db-062b-4462-8c99-4b78a92edef1.png'
        },
        {
            id : 3,
            title : 'Learn SQL',
            details : 'A SQLite course from Codecademy',
            date : '3/1/2022',
            field : 'Database',
            image : 'https://user-images.githubusercontent.com/91221861/166744339-722071d5-e7ad-4dc0-9ed4-9d7d4525dbfb.png'
        },
        {
            id : 4,
            title : 'Learn JavasScript',
            details : 'Programming course from Codecademy Front end engineer path',
            date : '12/21/2021',
            field : 'Programming',
            image : 'https://user-images.githubusercontent.com/91221861/166745095-a6fbab58-137c-4ea9-9883-4729eb9952b7.png'
        },
        {
            id : 5,
            title : 'Learn Advanced Python3',
            details : 'Programming course from Codecademy Pro with prerequisite Python for beginners and intermediate Python',
            date : '4/5/2022',
            field : 'Data Science',
            image : 'https://user-images.githubusercontent.com/91221861/166745694-21b9a15e-cdd4-4d42-955f-0786279333b5.png'
        },

        {
            id : 6,
            title : 'Learn Responsive Design',
            details : 'Web development course from Codecademy Front end engineer path',
            date : '10/20/2021',
            field : 'Web Development',
            image : 'https://user-images.githubusercontent.com/91221861/166746013-6292b1f7-0286-41ad-bf32-7977e8365a60.png'
        }


    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/